import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .profile-page {
    .profile-area {
      padding: 70px 0;
      .profile-card {
        background: #ffffff;
        border: 1px solid ${colors.border1};
        border-radius: 6px;
        box-shadow: 0 0 30px rgba(0, 0, 0, 0.08);
        padding: 30px;
        margin-bottom: 30px;

        h4.section-title {
          font-size: 18px;
          color: ${colors.black1};
          font-weight: 600;
          margin-bottom: 20px;
          position: relative;
          padding-bottom: 10px;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 50px;
            height: 2px;
            background: ${colors.red};
          }
        }

        .form-row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -10px;

          .form-group {
            flex: 0 0 50%;
            max-width: 50%;
            padding: 0 10px 20px;

            label {
              display: block;
              font-size: 14px;
              color: ${colors.text3};
              font-weight: 500;
              margin-bottom: 6px;
            }

            input,
            textarea,
            select {
              width: 100%;
              border: 1px solid ${colors.border3};
              border-radius: 5px;
              padding: 12px 14px;
              font-size: 14px;
              color: ${colors.text1};
              background: #fff;
              &:focus {
                border-color: ${colors.red};
                outline: none;
              }
            }

            textarea {
              min-height: 120px;
              resize: vertical;
            }

            @media (max-width: 767px) {
              flex: 0 0 100%;
              max-width: 100%;
            }
          }
        }
      }

      .form-actions {
        display: flex;
        justify-content: flex-end;
        gap: 15px;

        button {
          font-size: 15px;
          color: #fff;
          background: ${colors.red_bg};
          border: none;
          border-radius: 5px;
          padding: 12px 26px;
          font-weight: 600;
          text-transform: uppercase;
          &:hover {
            background: ${colors.red_bg2};
          }
          &:disabled {
            opacity: 0.65;
            cursor: not-allowed;
          }
        }

        .back-btn {
          background: transparent;
          color: ${colors.text3};
          border: 1px solid ${colors.border3};
          &:hover {
            color: #fff;
            background: ${colors.red};
            border-color: ${colors.red};
          }
        }
      }

      .alert {
        margin-bottom: 20px;
      }
    }

    @media (max-width: 767px) {
      .profile-area {
        padding: 40px 0;
        .profile-card {
          padding: 20px;
        }
      }
    }
  }

  .toast-wrapper {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1050;

    .toast {
      min-width: 280px;
      box-shadow: 0 0 25px rgba(0, 0, 0, 0.2);
    }
  }
`;
